import { SVGProps } from 'react';

function PauseButton({ ...props }: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 80 80" {...props}>
      <path d="M42,2A40,40,0,1,0,82,42,40.015,40.015,0,0,0,42,2ZM38,58H30V26h8Zm16,0H46V26h8Z" transform="translate(-2 -2)" />
    </svg>
  );
}

export default PauseButton;
